(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fif-color-gallery')) {
  customElements.define('fif-color-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.track) return;
      this.track = this.querySelector('.fif-gallery__track');
      this.slides = [...this.querySelectorAll('[data-gallery-media]')];
      this.groups = JSON.parse(this.querySelector('[data-gallery-groups]').textContent)
        .filter(group => group.id && group.position)
        .sort((a, b) => a.position - b.position);
      this.previous = this.querySelector('.fif-gallery__previous');
      this.next = this.querySelector('.fif-gallery__next');
      this.current = this.querySelector('[data-current]');
      this.total = this.querySelector('[data-total]');
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.updateCounter(), { passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      this.setActiveMedia(this.dataset.selected);
    }
    setActiveMedia(mediaId) {
      if (!this.track) this.connectedCallback();
      const id = String(mediaId).split('-').pop();
      const selected = this.groups.find(group => String(group.id) === id);
      const start = selected ? selected.position : 1;
      const end = this.groups.find(group => group.position > start)?.position ?? Infinity;
      this.slides.forEach(slide => {
        slide.hidden = Number(slide.dataset.position) < start || Number(slide.dataset.position) >= end;
      });
      this.visibleSlides = this.slides.filter(slide => !slide.hidden);
      this.track.scrollTo({ left: 0, behavior: 'instant' });
      this.total.textContent = this.visibleSlides.length;
      this.updateCounter();
    }
    move(direction) {
      const index = Math.max(0, Math.min(this.visibleSlides.length - 1, this.index + direction));
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateCounter() {
      this.index = Math.max(0, Math.min(this.visibleSlides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
      this.current.textContent = this.visibleSlides.length ? this.index + 1 : 0;
      this.previous.disabled = this.index <= 0;
      this.next.disabled = this.index >= this.visibleSlides.length - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
